



export const treeSelectionHeliocleanSiteMutations = {
    SET_TREE_SELECTED_HELIOCLEAN_SITES_FLEET: (state, payload) => {
        state.treeSelectedHeliocleanSitesFleet = payload;
    }
};
